import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router';
import ReactToolboxStyles from 'react-toolbox/lib/link/theme';

/*
** This component wraps React Router link to add default
*  styles from React Toolbox. It also accepts an object
*  in the className property that will be merged with
*  in the final className.
 */

const RouterLink = (props) => {
  const { className, ...otherProps } = props;
  const styles = cx({
    [ReactToolboxStyles.link]: true,
    [className]: className !== undefined,
  });

  return (
    <Link className={styles} {...otherProps} >
      {props.children}
    </Link>
  );
};

RouterLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default RouterLink;



// WEBPACK FOOTER //
// ./client/app/shared/components/RouterLink/index.jsx